var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memories"},[_c('HeroHeader',{attrs:{"title":"Memories","class-name":"memories"}}),_c('main',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('ArticleCards',{attrs:{"collection":_vm.cards}})],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }